/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  get(conversationId) {
    const accountId = ScheduledMessagesAPI.getAccountId();
    return axios.get(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/scheduled_messages`
    );
  }

  show(conversationId, id) {
    const accountId = ScheduledMessagesAPI.getAccountId();
    return axios.get(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/scheduled_messages/${id}`
    );
  }

  create(conversationId, scheduledMessageObj) {
    const accountId = ScheduledMessagesAPI.getAccountId();
    return axios.post(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/scheduled_messages`,
      scheduledMessageObj
    );
  }

  update(conversationId, id, scheduledMessageObj) {
    const accountId = ScheduledMessagesAPI.getAccountId();
    return axios.patch(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/scheduled_messages/${id}`,
      scheduledMessageObj
    );
  }

  delete(conversationId, id) {
    const accountId = ScheduledMessagesAPI.getAccountId();
    return axios.delete(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/scheduled_messages/${id}`
    );
  }

  static getAccountId() {
    const { pathname } = window.location;
    const match = pathname.match(/accounts\/(\d+)/);
    return match ? match[1] : null;
  }
}

export default new ScheduledMessagesAPI();
